import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import {
  Layout,
  Breadcrumb,
  Form,
  Input,
  Select,
  Switch,
  Tag,
  Icon,
  Button,
  Checkbox,
  message,
  notification,
  Skeleton,
  Popover,
  Radio,
  Tabs,
  InputNumber,
  List,
  Card,
  Divider,
  Row,
  Col,
  Avatar,
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import _ from 'lodash';
import styles from './styles.module.scss';
import whttp from '../../libs/whttp';
import { API_HOST, Role, GOOGLE_MAP_KEY } from '../../configs/env';
import AppHelper from 'libs/AppHelper';
import CitySelect from 'components/CitySelect/CitySelect';
import WUpload, { AvatarUpload } from 'components/WUpload/WUpload';
import { genFormItemAtrribute } from 'libs/FormHelper';
import Validator from 'validatorjs';
import Errors from 'validatorjs/src/errors';
import ValidatorErrorAlert from '../../components/ValidatorErrorAlert/ValidatorErrorAlert';
import GoogleMapReact from 'google-map-react';

const Option = Select.Option;

const cardBodyStyle = { padding: 8, fontSize: 8 };
const listGrid = { gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4 };

export default class BrandInfo extends Component {
  formRef = React.createRef();
  state = {
    brandInfo: {
      id: null,
      status: 1,
      name: null,
      type: 1,
    },
    data: [],
    messages: {},
    isFetchData: false,
    isSubmitData: false,
    isImage: false,
  };

  componentDidMount() {
    AppHelper.updateConfig();

    this.fetchData();
    this.fillData();
  }

  fillData = (data = _.cloneDeep(devBrandInfo)) => {
    if (!this.formRef.current) return;

    // 處理資料，本地適合Form Control的資料

    if (!_.isBoolean(data.status)) data.status = data.status === 1;

    this.formRef.current.setFieldsValue(data);
  };
  // 抓取頁面資訊
  fetchData = () => {
    const id = _.get(this, 'props.match.params.id');

    if (!id) return;

    this.setState({ isFetchData: true });
    whttp.get(API_HOST + `/api/mgt/v1/categories/${id}`, null, (state, res) => {
      this.setState({ isFetchData: false });

      const { code = 100, reason = '發生錯誤', data = {} } = res;

      console.log(code, reason, data, res);

      if (state === false || code !== 200) {
        message.warning(reason);
        this.props.history.replace('/category');
        return;
      }

      this.fillData(data);
    });
  };
  submitData = (brandInfo = {}) => {
    const current_user = _.get(window, 'VC_CONFIG.WP_CURRENT_USER', '');
    brandInfo.user_id = current_user.ID;
    // 把Control元件轉換回上傳資料
    const id = _.get(this, 'props.match.params.id', '');

    this.setState({ isSubmitData: true, messages: {} });

    whttp.post(
      API_HOST + `/api/mgt/v1/categories/${id}`,
      brandInfo,
      (state, res) => {
        console.log(state, res);
        this.setState({ isSubmitData: false });

        const { code = 100, reason = '發生錯誤', data = {} } = res;

        if (state === false) {
          return message.error('發生錯誤');
        }

        if (code !== 200) {
          notification['error']({
            message: '更新失敗',
            description: reason,
          });

          return this.setState({ messages: data.messages || {} });
        }

        const { data: { id: new_id } = {} } = res;

        if (new_id != id) {
          message.success('建立成功');
          this.setState({ brandInfo: data });

          return this.props.history.replace(`/category/view/${new_id}`);
        }

        message.success('更新成功');
      }
    );
  };

  deleteUser = (e) => {
    const id = _.get(this, 'props.match.params.id');

    if (!id) return;

    this.setState({ isDeleteUser: true });
    whttp.delete(
      API_HOST + `/api/mgt/v1/categories/${id}`,
      {},
      (state, res) => {
        this.setState({ isDeleteUser: false });
        const { code = 100, reason = '發生錯誤', data = {} } = res;

        if (state === false) {
          return message.error('發生錯誤');
        }

        if (code !== 200) {
          return message.error(reason);
        }

        notification['success']({
          message: '刪除成功',
        });

        return this.props.history.replace(`/category`);
      }
    );
  };

  enterNotSubmit = (e) => {
    if (e.key === 'Enter') {
      let value = e.target + '';
      if (value.indexOf('TextArea') !== -1) {
        console.log('TextArea');
      } else e.preventDefault();
    }
  };

  render() {
    const errors = _.get(this, 'state.validator.errors', new Errors());
    const options = _.get(this, 'props.app.options', {});

    const uploadList =
      this.formRef.current &&
      _.isArray(this.formRef.current.getFieldValue('uploadList'))
        ? this.formRef.current.getFieldValue('uploadList')
        : [];
    return (
      <Layout className={styles.container}>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to={`/category`}>類別管理</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>類別資訊</Breadcrumb.Item>
        </Breadcrumb>

        <h2>
          類別資訊<span />
        </h2>

        <ValidatorErrorAlert errors={errors} />

        <Skeleton loading={this.state.isFetchData}>
          <div className='block search'>
            <Form
              ref={this.formRef}
              name='basic'
              className='basicForm'
              layout='vertical'
              onFinish={(values) => this.submitData(values)}
              onKeyDown={(e) => {
                this.enterNotSubmit(e);
              }}
              onValuesChange={(changedFields, allFields) =>
                console.log('onValuesChange', changedFields)
              }
            >
              <Form.Item
                style={{ textAlign: 'right' }}
                taillayout={{ wrapperCol: { offset: 8, span: 16 } }}
              >
                <Button
                  type='primary'
                  htmlType='submit'
                  style={{ marginLeft: 8 }}
                  loading={this.state.isSubmitData}
                >
                  儲存
                </Button>
              </Form.Item>

              <div className='flexBox'>
                <Form.Item {...genFormItemAtrribute('name', '名稱')}>
                  <Input />
                </Form.Item>
                <Form.Item {...genFormItemAtrribute('sort', '排序')}>
                  <InputNumber style={{ width: '100%' }} min={0} />
                </Form.Item>
                <Form.Item
                  {...genFormItemAtrribute('status', '狀態', 'checked')}
                >
                  <Switch checkedChildren='啟用' unCheckedChildren='停用' />
                </Form.Item>
              </div>
              <div className='flexBox'>
                <Form.Item
                  {...genFormItemAtrribute('type', '類別')}
                  rules={[{ required: true, message: '請選擇類別' }]}
                >
                  <Radio.Group>
                    <List
                      //grid={listGrid}
                      dataSource={_.get(options, 'category_types', [])}
                      renderItem={(item) => (
                        <List.Item>
                          <Radio value={item.id}>{item.name}</Radio>
                        </List.Item>
                      )}
                    />
                  </Radio.Group>
                </Form.Item>
              </div>
            </Form>
          </div>
        </Skeleton>
      </Layout>
    );
  }
}

const devBrandInfo = {
  name: '類別名稱',
  type: 1,
  sort: null,
};



// WEBPACK FOOTER //
// ./src/views/Category/CategoryInfo.js